import { ProductGateway } from '../../../types/AvantArteProduct';
import {
  ProductStoryblok,
  ProductV2Storyblok,
} from '../../../types/generated-storyblok';
import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../types/Purchasing';
import { ProductFraming } from './ProductFraming';
import ProductVariants from './ProductVariants';

const ProductVariantOptions = <T extends ProductPurchaseDetails>({
  product,
  productsGateway,
  purchasingController,
}: {
  product: ProductStoryblok | ProductV2Storyblok;
  purchasingController: ProductPurchasingController<T>;
  productsGateway: ProductGateway;
}) => {
  return (
    <div className="flex w-full flex-col flex-wrap items-center justify-center gap-y-4 empty:hidden sm:flex-row sm:divide-x sm:divide-divider/20">
      <ProductFraming
        product={product as unknown as ProductType}
        productsGateway={productsGateway}
        purchasing={purchasingController}
      />
      <ProductVariants
        product={product as unknown as ProductType}
        productsGateway={productsGateway}
        purchasing={purchasingController}
      />
    </div>
  );
};

export default ProductVariantOptions;
